<template>
  <div class="p-4 grid gap-4">
    <!-- 카드형식 리스트-->
    <div v-for="item in list" class="px-4 py-8  rounded-lg" :class="[item.disabled ? 'shadow-drop' : 'shadow-md cursor-pointer']" @click="clickItem(item)">
      <h4 class="font-bold" style="font-size: 1.2rem;" :style="{ color: item.disabled ? '#999999' : '#7E72F2'}">{{ item.title }}</h4>
      <div class="mt-2" :style="{ color: item.disabled ? '#999999' : ''}">{{ item.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrScanBoard',
  data() {
    return {
      list: [
        {
          boardId: 1040,
          title: '인원·장비 투입 QR 스캔',
          description: '일 투입 현황 출입 기록용 스캔',
        },
        {
          boardId: 434,
          title: '안전·보건 교육 QR 스캔',
          description: '안전·보건 교육 근로자 이수 기록용 스캔',
          disabled: true
        }
      ]
    };
  },
  methods: {
    clickItem (item) {
      if (!item.disabled) {
        this.$emit("click", item)
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
